import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ErrorStore,
  FormHeaderComponent,
  GlobalErrorComponent,
  IdentityStore,
  ResetPassword,
  ResetPasswordFormComponent,
  TenantStore,
} from '../../../index';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { MessageComponent, FaIconComponent } from '@akostm/orbit-ui';

@Component({
  selector: 'shared-main-reset-password',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    FaIconComponent,
    MessageComponent,
    ResetPasswordFormComponent,
    FormHeaderComponent,
    GlobalErrorComponent,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent {
  readonly tenantStore = inject(TenantStore);
  readonly #identityStore = inject(IdentityStore);
  readonly spinnerIcon = faSpinnerThird;
  #translateService: TranslateService = inject(TranslateService);
  readonly #toastr = inject(ToastrService);
  readonly #errorStore = inject(ErrorStore);
  readonly #tenantErrorCodes = [
    'error.identity.tenant_not_found_or_disabled',
    'error.frontends.tenant_not_found_or_disabled',
  ];
  readonly tenantErrors = computed(() =>
    this.#errorStore.getErrorsByCodesAndType(this.#tenantErrorCodes, 'global')
  );
  readonly #resetPasswordErrorCodes = ['error.http.not_found'];
  readonly resetPasswordErrors = computed(() =>
    this.#errorStore.getErrorsByCodesAndType(this.#resetPasswordErrorCodes, 'inline')
  );

  async resetPassword(request: ResetPassword) {
    this.resetResetPasswordErrors();
    await this.#identityStore.resetPassword(request);
    if (this.resetPasswordErrors().length === 0) {
      this.#toastr.success(
        this.#translateService.instant('SHARED.PAGES.RESET_PASSWORD.RESET_EMAIL_HAS_BEEN_SENT')
      );
    }
  }

  resetResetPasswordErrors() {
    this.#errorStore.clearErrorsByCodes(this.#resetPasswordErrorCodes);
  }
}
